import ValidateForm from "./ValidateForm";

export const updateFormElements = (event, field, Form) => {
  const identifier = event.target.getAttribute("name");
  const refFormData = {
    ...Form
  };
  const refFormDataElement = {
    ...refFormData[identifier]
  };
  switch (field) {
    case "validation":
      refFormDataElement.valid = ValidateForm(
        refFormDataElement.value,
        refFormDataElement.validation
      );
      if (refFormDataElement.hasOwnProperty("blurred")) {
        refFormDataElement.blurred = true;
      }
      break;
    case "checkbox":
      refFormDataElement.value = event.target.checked;
      refFormDataElement.valid = ValidateForm(
        refFormDataElement.value,
        refFormDataElement.validation
      );
      break;
    default:
      refFormDataElement.value = event.target.value;
      break;
  }
  refFormDataElement.typing = true;
  refFormData[identifier] = refFormDataElement;
  return refFormData;
};

export const checkFormValid = form => {
  let formValid = true;
  let fieldValid;
  const refFormData = {
    ...form
  };
  for (const key in refFormData) {
    if (Object.prototype.hasOwnProperty.call(refFormData, key)) {
      const refFormDataElement = {
        ...refFormData[key]
      };
      fieldValid = ValidateForm(
        refFormDataElement.value.toString(),
        refFormDataElement.validation
      );
      refFormDataElement.valid = fieldValid;
      refFormData[key] = refFormDataElement;
      if (formValid && !fieldValid) {
        formValid = fieldValid;
      }
    }
  }
  return { form: refFormData, formValid: formValid };
};
